import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';
import { OrderListComponent } from './order-list/order-list.component';
import { CommonModule } from '@angular/common';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { OrdersRoutingModule } from './orders-routing.module';
import { OrderFilterComponent } from './order-filter/order-filter.component';
import { OrderPageContainer } from './order-page-container/order-page.container';

@NgModule({
  imports: [CommonModule, FlorderModule, OrdersRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  exports: [],
  declarations: [
    OrderFilterComponent,
    OrderListComponent,
    OrderPageContainer,
  ],
})
export class OrdersModule {}
